import Button from 'components/ui/Button/Button';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import ScreenshotSupport from '../ScreenshotSupport';

interface CityNameModalProps {
  close: () => void;
  onSave: (cityName: string) => void;
  cityName: string;
}

const CityNameModal: FC<CityNameModalProps> = ({ close, onSave, cityName }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    setValue(cityName);
  }, [cityName]);

  const onClickSave = () => {
    setIsSubmitted(true);
    const trimmed = value.trim();
    if (!trimmed) {
      return;
    }

    close();
    onSave(trimmed);
  };

  return (
    <Fragment>
      {createPortal(
        <div className="modal-overlay modal-overlay-top">
          <div className="modal active">
            <div className="modal-title">
              <div className="title">{t('proposal.edit')}</div>
              <div>
                <ScreenshotSupport />
                <FontAwesomeIcon icon={faTimes} onClick={close} />
              </div>
            </div>
            <div className="modal-content">
              <div className={'form-group' + (isSubmitted && !value.trim() ? ' is-invalid' : '')}>
                <label>{t('city', { defaultValue: 'City' })}</label>
                <input
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  className="form-control"
                />
                {isSubmitted && !value.trim() && (
                  <div className="form-invalid-text">{t('validation.required')}</div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <Button className="btn btn-default" title={t('close')} onClick={close} />
              <Button className="btn btn-primary" title={t('save')} onClick={onClickSave} />
            </div>
          </div>
        </div>,
        document.body,
      )}
    </Fragment>
  );
};

export default CityNameModal;
